import type { Translations } from '~/modules/core/interfaces';
import type { ArticleDecisionTreeLabels } from '~/modules/landing/interfaces';

export function readArticleDecisionTreeLabels(
    translations: Translations,
    prefix: string,
): ArticleDecisionTreeLabels | null {
    const labels = {
        yes: translations[`${prefix}.yes`] ?? '',
        no: translations[`${prefix}.no`] ?? '',
        back: translations[`${prefix}.back`] ?? '',
        restart: translations[`${prefix}.restart`] ?? '',
        result: translations[`${prefix}.result_label`] ?? '',
    };

    if (!labels.yes || !labels.no || !labels.back || !labels.restart) {
        return null;
    }

    return labels;
}
